<template>
	<TopMenu :breadcrumbs="breadcrumbs"/>
	<div class="block">
		<div class="block__header block__header--nopadding">
			<Navigator :items="nav"/>
		</div>
		<div class="block__body">
      <div class="load-container" :class="{'load' : isLoad}">
        <template v-if="!isLoad">
          <EditForm :organization="organization" :house="null"/>
        </template>
      </div>
		</div>
	</div>
</template>

<script setup>
  import TopMenu from '@/components/TopMenu.vue'
  import Navigator from '@/components/Navigator.vue'
  import EditForm from '@/components/house/EditForm.vue'
</script>

<script>
  export default {
    name: 'PageHouseCreate',
    data: () => ({
      isLoad: true,
      breadcrumbs: [],
      nav: [],
      organization: null,
    }),
    computed: {
    	organization_id () {
    		return this.$route.params.organization_id;
    	},
    },
    created () {
      this.nav = [
        {name: 'Адрес дома', isActive: true},
        {name: 'Тех. параметры', isActive: false},
        {name: 'Структура', isActive: false},
        {name: 'Документы', isActive: false},
      ];
      Promise.all([
        this.loadOrganization(), 
      ])
      .then(() => {
        this.breadcrumbs = [
          {name: this.$route.meta.name, link: this.$route.matched[0].path, ico: this.$route.meta.ico},
          {name: this.organization.name, link: {name: 'PageOrganization', params: {organization_id: this.organization_id}}},
          {name: 'Добавить дом', link: ''},
        ];
      })
      .catch(()=> {})
      .finally(() => {
        this.isLoad = false;
      })
    },

    methods: {
    	async loadOrganization () {
      	const r = await this.axios.get(this.$store.state.api_endpoint + '/companies/' + this.organization_id);
        this.organization = r.data;
    	},
    },
  }
</script>

<style scoped>

</style>